require('./cardActivationView.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const { connect } = require('react-redux');
// @ commons
const { FormattedText, formatText, getFinalTitle } = require('core/i18n').i18n;
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');
const WizardError = require('components/commons/wizardError/wizardError');
const { CommercialAds } = require('components/commons/commercialAds/commercialAds');
// @ actions
const activateCardActions = require('actions/cardActivation.js');
const cardActivationR42Actions = require('actions/cardActivationR42');
const hireTravelPlusCCWrapUpActions = require('actions/hireTravelPlus');
// @ components
const CardDetailsSideBar = require('components/cards/cardDetailsSidebar/cardDetailsSidebar');
const CardActivatorForm = require('components/cards/cardActivator/cardActivatorForm/cardActivatorForm');
const CardActivatorSuccess = require('components/cards/cardActivator/cardActivatorSuccess/cardActivatorSuccess');
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const CardActivationR42 = require('components/cards/cardActivationR42/cardActivationR42');
//@utilities
const { cardConstants } = require('utilities/accessHelperConditions/cards');
const AccessHelper = require('utilities/accessHelper');
// @ constants
const { PROC_ACTIVATE_CARD } = require('utilities/tagging');


class CardActivationView extends React.Component {
    constructor(props) {
        super(props);
        this.isReady = this.isReady.bind(this);
    }

    componentDidMount() {
        const { history, immCards, match: { params: { cardId } } } = this.props;
        const immCard = immCards.getIn(['byId', cardId]);

        AccessHelper.allowAccess(cardConstants.CARD_ACTIVATION, { immCard }, history);
    }

    componentWillUnmount() {
        this.props.clearCardActivation();
    }

    buildError(immCard) {
        const errorTitle = formatText('cardActivate-errorTitle');
        const goBackButtonLabel = formatText('cardActivate-errorBackToCards');
        const linkToDetails = '/myprofile/cards';
        const goBackButton = {
            label: goBackButtonLabel,
            url: linkToDetails
        }
        return (
            <article className="row no-gutter">
                <div className="col-xs-offset-2 col-xs-8">
                    <WizardError
                        errorMessage={errorTitle}
                        processType={PROC_ACTIVATE_CARD}
                        mainButton={goBackButton}
                    >
                        <section className="row no-gutter">
                            <div className="col-xs-5">
                                <CommercialAds path="cards" type="cards" immCard={immCard} size="medium" />
                            </div>
                            <div className="col-xs-7">
                                <FormattedText
                                    value="cardActivate-errorSubMessage"
                                />
                            </div>
                        </section>
                    </WizardError>
                </div>
            </article>
        );
    }

    isReady() {
        return false;
    }

    render() {
        const {
            activateCard,
            activateCardR42,
            hireTravelPlusCCWrapUpOnFailure,
            hireTravelPlusCCWrapUpOnStart,
            hireTravelPlusCCWrapUpOnSuccess,
            immCardActivation,
            immCardActivationR42,
            immCards,
            immGlobalVariables,
            immTravelPlus,
            match: { params: { cardId } },
            resetActivationR42,
            setTravelPlusStateR42,
            setVisibleStepR42,
            setWillCancelR42,
            toggleHireTravelPlus,
            validateStepR42,
        } = this.props;
        const immCard = immCards.get('byId').get(cardId);

        let block;

        if (immCard) {
            const type = immCard.get('type');
            const travelSwitchVisible = immCard.getIn(['r42', 'travelSwitchVisible']);
            const vip = immCard.getIn(['r42', 'vip']);
            const subtitleLeft = formatText(`cards-${type}`);
            const subtitleRight = immCard.get('alias').get('current');
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-cards'),
                    url: '/myprofile/cards'
                },
                {
                    text: formatText('cards-activate')
                }
            ];
            let blockContent;

            if (travelSwitchVisible ) {
                blockContent = (
                    <div className="row">
                        <CardActivationR42
                            activateCardR42={activateCardR42}
                            hireTravelPlusCCWrapUpOnFailure={hireTravelPlusCCWrapUpOnFailure}
                            hireTravelPlusCCWrapUpOnStart={hireTravelPlusCCWrapUpOnStart}
                            hireTravelPlusCCWrapUpOnSuccess={hireTravelPlusCCWrapUpOnSuccess}
                            immCard={immCard}
                            immCardActivationR42={immCardActivationR42}
                            immGlobalVariables={immGlobalVariables}
                            immTravelPlus={immTravelPlus}
                            resetActivation={resetActivationR42}
                            setTravelPlusState={setTravelPlusStateR42}
                            setVisibleStep={setVisibleStepR42}
                            setWillCancel={setWillCancelR42}
                            toggleHireTravelPlus={toggleHireTravelPlus}
                            validateStep={validateStepR42}
                            travelSwitchVisible={travelSwitchVisible}
                            vip={vip}
                        />
                    </div>
                );
            } else {
                if (!!immCardActivation.get('error')) {
                    blockContent = this.buildError(immCard);
                } else if (immCardActivation.get('success')) {
                    blockContent = (
                        <div className="row no-gutter">
                            <div className="col-xs-offset-2 col-xs-8">
                                <CardActivatorSuccess
                                    immCard={immCard}
                                    immCardActivationR42={immCardActivationR42}
                                />
                            </div>
                        </div>
                    );
                } else {
                    const acceptText = formatText('wizard-redirectConfirmationAcceptButton');
                    const cancelText = formatText('wizard-redirectConfirmationCancelButton');
                    const confirmationTitle = formatText('wizard-redirectConfirmationTitle');
                    const confirmationMessage = formatText('wizard-redirectConfirmationMessage');
                    blockContent = (
                        <div className="row no-outside-gutter">
                            <PreLeaveModalComponent
                                acceptText={acceptText}
                                confirmationMessage={confirmationMessage}
                                confirmationTitle={confirmationTitle}
                                cancelText={cancelText}
                                isReady={this.isReady}
                            />
                            <div className="col-xs-8">
                                <CardActivatorForm
                                    immCard={immCard}
                                    immCardActivation={immCardActivation}
                                    activateCard={activateCard}
                                />
                            </div>
                            <div className="col-xs-4">
                                <CardDetailsSideBar immCard={immCard} />
                            </div>
                        </div>
                    );
                }
            }

            block = (
                <article className="card-activation-view" id="printable-wizard">
                    <OKCover size="medium" section="cards">
                        <OKHeaderSubPage
                            breadcrumbConfig={mappingBreadcrumb}
                            subtitleLeft={subtitleLeft}
                            subtitleRight={subtitleRight}
                            finalTitle={getFinalTitle('cardActivate-cardActivation')}
                        >
                        </OKHeaderSubPage>
                    </OKCover>
                    <section className="card-activation-view__body">
                        {blockContent}
                    </section>
                </article>
            );
        } else {
            block = <LoadingSection />;
        }

        return block;
    }
}

CardActivationView.propTypes = {
    activateCardR42: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnFailure: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnStart: PropTypes.func.isRequired,
    hireTravelPlusCCWrapUpOnSuccess: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immCards: PropTypes.object.isRequired,
    immCardActivation: PropTypes.object.isRequired,
    immCardActivationR42: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immTravelPlus: PropTypes.object.isRequired,
    activateCard: PropTypes.func.isRequired,
    clearCardActivation: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    resetActivationR42: PropTypes.func.isRequired,
    setTravelPlusStateR42: PropTypes.func.isRequired,
    setVisibleStepR42: PropTypes.func.isRequired,
    setWillCancelR42: PropTypes.func.isRequired,
    toggleHireTravelPlus: PropTypes.func.isRequired,
    validateStepR42: PropTypes.func.isRequired,
};

module.exports.constructor = CardActivationView;
module.exports.CardActivationView = connect(
    state => ({
        immCardActivation: state.cardActivation,
        immCardActivationR42: state.cardActivationR42,
        immCards: state.cards,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immGlobalVariables: state.globalVariables,
        immTravelPlus: state.hireTravelPlus,
    }), {
    activateCard: activateCardActions.activateCard,
    activateCardR42: cardActivationR42Actions.activateCardR42,
    clearCardActivation: activateCardActions.clearCardActivation,
    hireTravelPlusCCWrapUpOnFailure: hireTravelPlusCCWrapUpActions.hireTravelPlusCCWrapUpOnFailure,
    hireTravelPlusCCWrapUpOnStart: hireTravelPlusCCWrapUpActions.hireTravelPlusCCWrapUpOnStart,
    hireTravelPlusCCWrapUpOnSuccess: hireTravelPlusCCWrapUpActions.hireTravelPlusCCWrapUpOnSuccess,
    resetActivationR42: cardActivationR42Actions.reset,
    setTravelPlusStateR42: cardActivationR42Actions.setTravelPlusState,
    setVisibleStepR42: cardActivationR42Actions.setVisibleStep,
    setWillCancelR42: cardActivationR42Actions.setWillCancel,
    toggleHireTravelPlus: cardActivationR42Actions.toggleHireTravelPlus,
    validateStepR42: cardActivationR42Actions.validateStep,
})(withRouter(CardActivationView));
